/* src/app/views/template/components/templates/web/web-spotlight-templates/web-spotlight-templates.component.scss */
/*# sourceMappingURL=web-spotlight-templates.component.css.map */
